import React from "react";
import PropTypes from "prop-types";
import { ProgressBar, Loading } from "@evertrue/et-components";
import numeral from "numeral";
import { currencyFormatter } from "../utils/utils";
import RespondTo from "./respond-to";

const propTypes = {
  loading: PropTypes.bool,
  percent_dollars_raised_goal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  formatted_percent_dollars_raised_goal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  goals: PropTypes.object,
  filteredPool: PropTypes.object,
};
const PoolReportStats = ({
  loading,
  percent_dollars_raised_goal,
  formatted_percent_dollars_raised_goal,
  goals,
  filteredPool,
}) => {
  return (
    <React.Fragment>
      <RespondTo className="pool-report--perf-section">
        <div className="pool-report--label">Participation</div>
        <div className="pool-report--large-num">{numeral(filteredPool.pool_participation_rate).format("%0.[0]")}</div>
        <div>
          <span className="pool-report--label">Goal: </span>
          {numeral(goals.participation_goal / 100).format("%0.[00]") || "N/A"}
        </div>
      </RespondTo>

      <RespondTo className="pool-report--perf-section">
        {loading && <Loading />}
        <div className="pool-report--label">Dollars Raised</div>
        <div className="pool-report--large-num">{currencyFormatter(filteredPool.total_dollars_raised)}</div>
        <div>
          <span className="pool-report--label">Goal: </span>
          <span>{numeral(goals.dollar_amount_goal).format("$0,[00]'") || "N/A"}</span>
        </div>

        {goals.dollar_amount_goal ? (
          <RespondTo className="pool-report--bar-section">
            <ProgressBar
              className="pool-report--progress-bar"
              backgroundColor={"#d8d8d8"}
              width={172}
              percent={percent_dollars_raised_goal > 100 ? 100 : percent_dollars_raised_goal}
            />
            <span className="pool-report--goal-raised">{formatted_percent_dollars_raised_goal} of Goal Raised</span>
          </RespondTo>
        ) : null}
      </RespondTo>
    </React.Fragment>
  );
};

PoolReportStats.defaultProps = {
  filteredPool: {},
  goals: {},
};
PoolReportStats.propTypes = propTypes;

export default PoolReportStats;
